import React from 'react';
import { RichText as JSSRichText, RichTextField, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import styles from './RichTextWrapper.module.scss';
import { fixLinksFromRichTextEditor, useDictionary } from 'lib/utils';

export interface RichTextWrapperProps {
  className?: string;
  field: RichTextField;
  tag?: string;
  editable?: boolean;
}

const cx = classNames.bind(styles);

const RichTextWrapper: React.FC<RichTextWrapperProps> = (props) => {
  const { className, field, tag, editable, ...rest } = props;
  const classes = cx('rich-text', className);
  const { sitecoreContext } = useSitecoreContext();
  const opensInNewWindowText = useDictionary('Aria-Label-ExternalLinkSuffix');

  if (field.value && sitecoreContext && typeof window !== 'undefined') {
    if (!sitecoreContext.pageEditing) {
      field.value = fixLinksFromRichTextEditor(field.value, opensInNewWindowText);
    }

    //TODO: This call may be uneccessary, but leaving it in for now. If we can confirm that the RTE fixes are working as expected, we can remove this call.
    // if (sitecoreContext?.pageState === LayoutServicePageState.Normal) {
    //   field.value = field.value.replaceAll('src="-/media', 'src="/-/media').replaceAll("src='-/media", "src='/-/media");
    // }
  }

  return (
    <JSSRichText
      className={`rich-text ${classes}`}
      field={{ ...field, value: field.value }}
      tag={tag}
      editable={editable}
      {...rest}
    />
  );
};

export default RichTextWrapper;
